var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordMarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "da455bdd3d"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.500002, 166.742206)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 30.203125 0 L 3.21875 0 L 3.21875 -37.828125 L 30.203125 -37.828125 L 30.203125 -30.3125 L 11.796875 -30.3125 L 11.796875 -22.703125 L 27.53125 -22.703125 L 27.53125 -15.1875 L 11.796875 -15.1875 L 11.796875 -7.515625 L 30.203125 -7.515625 Z M 30.203125 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.849578, 166.742206)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 40.625 0 L 31.921875 0 L 28.8125 -9.4375 L 12.875 -9.4375 L 9.765625 0 L 1.078125 0 L 13.84375 -37.828125 L 27.796875 -37.828125 Z M 19.75 -30.3125 L 15.34375 -16.953125 L 26.296875 -16.953125 L 21.890625 -30.3125 Z M 19.75 -30.3125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.387703, 166.742206)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 36.546875 -10.40625 C 36.546875 -8.257812 36 -6.363281 34.90625 -4.71875 C 33.8125 -3.070312 32.082031 -1.785156 29.71875 -0.859375 C 27.363281 0.0664062 24.234375 0.53125 20.328125 0.53125 C 15.785156 0.53125 12.144531 -0.0664062 9.40625 -1.265625 C 6.675781 -2.460938 4.691406 -4.1875 3.453125 -6.4375 C 2.222656 -8.6875 1.609375 -11.40625 1.609375 -14.59375 L 10.1875 -14.59375 C 10.1875 -11.695312 10.984375 -9.703125 12.578125 -8.609375 C 14.171875 -7.515625 16.847656 -6.96875 20.609375 -6.96875 C 23.359375 -6.96875 25.269531 -7.269531 26.34375 -7.875 C 27.414062 -8.488281 27.953125 -9.296875 27.953125 -10.296875 C 27.953125 -11.234375 27.488281 -12.015625 26.5625 -12.640625 C 25.632812 -13.265625 24.410156 -13.851562 22.890625 -14.40625 C 21.367188 -14.957031 19.675781 -15.539062 17.8125 -16.15625 C 15.8125 -16.832031 13.929688 -17.5 12.171875 -18.15625 C 10.421875 -18.820312 8.882812 -19.601562 7.5625 -20.5 C 6.238281 -21.394531 5.203125 -22.46875 4.453125 -23.71875 C 3.703125 -24.96875 3.328125 -26.523438 3.328125 -28.390625 C 3.328125 -31.609375 4.585938 -34.070312 7.109375 -35.78125 C 9.628906 -37.5 13.320312 -38.359375 18.1875 -38.359375 C 22.050781 -38.359375 25.222656 -37.757812 27.703125 -36.5625 C 30.191406 -35.363281 32.023438 -33.753906 33.203125 -31.734375 C 34.390625 -29.710938 34.984375 -27.453125 34.984375 -24.953125 L 26.40625 -24.953125 C 26.40625 -26.484375 26.046875 -27.675781 25.328125 -28.53125 C 24.609375 -29.394531 23.628906 -30 22.390625 -30.34375 C 21.160156 -30.6875 19.757812 -30.859375 18.1875 -30.859375 C 16.257812 -30.859375 14.726562 -30.632812 13.59375 -30.1875 C 12.46875 -29.738281 11.90625 -29.03125 11.90625 -28.0625 C 11.90625 -27.488281 12.066406 -27.003906 12.390625 -26.609375 C 12.710938 -26.210938 13.375 -25.789062 14.375 -25.34375 C 15.375 -24.90625 16.878906 -24.34375 18.890625 -23.65625 C 20.285156 -23.195312 21.773438 -22.6875 23.359375 -22.125 C 24.953125 -21.570312 26.523438 -20.945312 28.078125 -20.25 C 29.640625 -19.550781 31.054688 -18.738281 32.328125 -17.8125 C 33.597656 -16.882812 34.617188 -15.8125 35.390625 -14.59375 C 36.160156 -13.375 36.546875 -11.976562 36.546875 -10.40625 Z M 36.546875 -10.40625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.238932, 166.742206)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 20.4375 -22.046875 L 28.546875 -37.828125 L 37.71875 -37.828125 L 23.65625 -12.1875 L 23.65625 0 L 15.078125 0 L 15.078125 -12.1875 L 1.078125 -37.828125 L 10.25 -37.828125 L 18.296875 -22.046875 L 18.296875 -17.21875 L 20.4375 -17.21875 Z M 20.4375 -22.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.500002, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.546875 -37.828125 C 17.722656 -37.828125 20.484375 -37.484375 22.828125 -36.796875 C 25.171875 -36.117188 26.976562 -34.882812 28.25 -33.09375 C 29.519531 -31.3125 30.15625 -28.773438 30.15625 -25.484375 C 30.15625 -22.191406 29.519531 -19.640625 28.25 -17.828125 C 26.976562 -16.023438 25.171875 -14.773438 22.828125 -14.078125 C 20.484375 -13.378906 17.722656 -13.03125 14.546875 -13.03125 L 8.3125 -13.03125 L 8.3125 0 L 3.921875 0 L 3.921875 -37.828125 Z M 8.3125 -16.796875 L 14.59375 -16.796875 C 16.738281 -16.796875 18.648438 -17 20.328125 -17.40625 C 22.015625 -17.820312 23.335938 -18.644531 24.296875 -19.875 C 25.265625 -21.113281 25.75 -22.984375 25.75 -25.484375 C 25.75 -27.953125 25.265625 -29.800781 24.296875 -31.03125 C 23.335938 -32.269531 22.015625 -33.085938 20.328125 -33.484375 C 18.648438 -33.878906 16.738281 -34.078125 14.59375 -34.078125 L 8.3125 -34.078125 Z M 8.3125 -16.796875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.420275, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.3125 0 L 3.921875 0 L 3.921875 -37.828125 L 16.46875 -37.828125 C 19.476562 -37.828125 22.09375 -37.53125 24.3125 -36.9375 C 26.53125 -36.351562 28.238281 -35.300781 29.4375 -33.78125 C 30.632812 -32.257812 31.234375 -30.082031 31.234375 -27.25 C 31.234375 -24.425781 30.566406 -22.328125 29.234375 -20.953125 C 27.910156 -19.578125 26.234375 -18.707031 24.203125 -18.34375 L 24.203125 -17.0625 L 28.703125 -17.0625 C 29.773438 -17.0625 30.539062 -16.835938 31 -16.390625 C 31.46875 -15.941406 31.703125 -15.21875 31.703125 -14.21875 L 31.703125 0 L 27.3125 0 L 27.3125 -15.1875 L 8.3125 -15.1875 Z M 8.3125 -34.078125 L 8.3125 -18.9375 L 16.46875 -18.9375 C 18.613281 -18.9375 20.460938 -19.085938 22.015625 -19.390625 C 23.578125 -19.703125 24.769531 -20.394531 25.59375 -21.46875 C 26.414062 -22.539062 26.828125 -24.21875 26.828125 -26.5 C 26.828125 -28.832031 26.414062 -30.535156 25.59375 -31.609375 C 24.769531 -32.679688 23.578125 -33.359375 22.015625 -33.640625 C 20.460938 -33.929688 18.613281 -34.078125 16.46875 -34.078125 Z M 8.3125 -34.078125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.808321, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.375 -18.9375 C 3.375 -22.625 4.070312 -25.925781 5.46875 -28.84375 C 6.863281 -31.757812 8.882812 -34.070312 11.53125 -35.78125 C 14.175781 -37.5 17.363281 -38.359375 21.09375 -38.359375 C 24.769531 -38.359375 27.921875 -37.5 30.546875 -35.78125 C 33.179688 -34.070312 35.195312 -31.757812 36.59375 -28.84375 C 37.988281 -25.925781 38.6875 -22.625 38.6875 -18.9375 C 38.6875 -15.257812 37.988281 -11.953125 36.59375 -9.015625 C 35.195312 -6.078125 33.179688 -3.75 30.546875 -2.03125 C 27.921875 -0.320312 24.769531 0.53125 21.09375 0.53125 C 17.363281 0.53125 14.175781 -0.320312 11.53125 -2.03125 C 8.882812 -3.75 6.863281 -6.078125 5.46875 -9.015625 C 4.070312 -11.953125 3.375 -15.257812 3.375 -18.9375 Z M 7.78125 -18.9375 C 7.78125 -15.9375 8.257812 -13.242188 9.21875 -10.859375 C 10.1875 -8.484375 11.664062 -6.613281 13.65625 -5.25 C 15.644531 -3.894531 18.125 -3.21875 21.09375 -3.21875 C 24.0625 -3.21875 26.519531 -3.894531 28.46875 -5.25 C 30.414062 -6.613281 31.867188 -8.484375 32.828125 -10.859375 C 33.796875 -13.242188 34.28125 -15.9375 34.28125 -18.9375 C 34.28125 -21.945312 33.796875 -24.628906 32.828125 -26.984375 C 31.867188 -29.347656 30.414062 -31.207031 28.46875 -32.5625 C 26.519531 -33.925781 24.0625 -34.609375 21.09375 -34.609375 C 18.125 -34.609375 15.644531 -33.925781 13.65625 -32.5625 C 11.664062 -31.207031 10.1875 -29.347656 9.21875 -26.984375 C 8.257812 -24.628906 7.78125 -21.945312 7.78125 -18.9375 Z M 7.78125 -18.9375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.795068, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.546875 -37.828125 C 17.722656 -37.828125 20.484375 -37.484375 22.828125 -36.796875 C 25.171875 -36.117188 26.976562 -34.882812 28.25 -33.09375 C 29.519531 -31.3125 30.15625 -28.773438 30.15625 -25.484375 C 30.15625 -22.191406 29.519531 -19.640625 28.25 -17.828125 C 26.976562 -16.023438 25.171875 -14.773438 22.828125 -14.078125 C 20.484375 -13.378906 17.722656 -13.03125 14.546875 -13.03125 L 8.3125 -13.03125 L 8.3125 0 L 3.921875 0 L 3.921875 -37.828125 Z M 8.3125 -16.796875 L 14.59375 -16.796875 C 16.738281 -16.796875 18.648438 -17 20.328125 -17.40625 C 22.015625 -17.820312 23.335938 -18.644531 24.296875 -19.875 C 25.265625 -21.113281 25.75 -22.984375 25.75 -25.484375 C 25.75 -27.953125 25.265625 -29.800781 24.296875 -31.03125 C 23.335938 -32.269531 22.015625 -33.085938 20.328125 -33.484375 C 18.648438 -33.878906 16.738281 -34.078125 14.59375 -34.078125 L 8.3125 -34.078125 Z M 8.3125 -16.796875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.715341, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 27.359375 0 L 3.921875 0 L 3.921875 -37.828125 L 27.359375 -37.828125 L 27.359375 -34.078125 L 8.3125 -34.078125 L 8.3125 -20.8125 L 24.6875 -20.8125 L 24.6875 -17.0625 L 8.3125 -17.0625 L 8.3125 -3.75 L 27.359375 -3.75 Z M 27.359375 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.382464, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.3125 0 L 3.921875 0 L 3.921875 -37.828125 L 16.46875 -37.828125 C 19.476562 -37.828125 22.09375 -37.53125 24.3125 -36.9375 C 26.53125 -36.351562 28.238281 -35.300781 29.4375 -33.78125 C 30.632812 -32.257812 31.234375 -30.082031 31.234375 -27.25 C 31.234375 -24.425781 30.566406 -22.328125 29.234375 -20.953125 C 27.910156 -19.578125 26.234375 -18.707031 24.203125 -18.34375 L 24.203125 -17.0625 L 28.703125 -17.0625 C 29.773438 -17.0625 30.539062 -16.835938 31 -16.390625 C 31.46875 -15.941406 31.703125 -15.21875 31.703125 -14.21875 L 31.703125 0 L 27.3125 0 L 27.3125 -15.1875 L 8.3125 -15.1875 Z M 8.3125 -34.078125 L 8.3125 -18.9375 L 16.46875 -18.9375 C 18.613281 -18.9375 20.460938 -19.085938 22.015625 -19.390625 C 23.578125 -19.703125 24.769531 -20.394531 25.59375 -21.46875 C 26.414062 -22.539062 26.828125 -24.21875 26.828125 -26.5 C 26.828125 -28.832031 26.414062 -30.535156 25.59375 -31.609375 C 24.769531 -32.679688 23.578125 -33.359375 22.015625 -33.640625 C 20.460938 -33.929688 18.613281 -34.078125 16.46875 -34.078125 Z M 8.3125 -34.078125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.892622, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.3125 -37.828125 L 32.9375 -37.828125 L 32.9375 -34.078125 L 19.859375 -34.078125 L 19.859375 0 L 15.5 0 L 15.5 -34.078125 L 2.3125 -34.078125 Z M 2.3125 -37.828125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.19282, 222.042876)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 18.296875 -19.375 L 28.859375 -37.828125 L 33.59375 -37.828125 L 19.859375 -14.109375 L 19.859375 0 L 15.5 0 L 15.5 -14.109375 L 1.765625 -37.828125 L 6.5 -37.828125 L 17.0625 -19.375 L 17.0625 -16.3125 L 18.296875 -16.3125 Z M 18.296875 -19.375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.543353, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.265625 0 L 1.265625 -12.34375 L 2.46875 -12.34375 L 7 -3.3125 L 11.53125 -12.34375 L 12.71875 -12.34375 L 12.71875 0 L 11.609375 0 L 11.609375 -10.296875 L 7.59375 -2.3125 L 6.390625 -2.3125 L 2.375 -10.296875 L 2.375 0 Z M 1.265625 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.044762, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.5 -3.265625 L 3.0625 -3.265625 L 1.9375 0 L 0.796875 0 L 5.25 -12.34375 L 6.328125 -12.34375 L 10.9375 0 L 9.65625 0 Z M 3.359375 -4.140625 L 8.171875 -4.140625 L 5.734375 -11 Z M 3.359375 -4.140625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.343743, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.328125 0 L 2.296875 -10.75 L 2.375 0 L 1.265625 0 L 1.265625 -12.34375 L 2.5625 -12.34375 L 9.578125 -1.59375 L 9.5 -12.34375 L 10.609375 -12.34375 L 10.609375 0 Z M 9.328125 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.607449, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.5 -3.265625 L 3.0625 -3.265625 L 1.9375 0 L 0.796875 0 L 5.25 -12.34375 L 6.328125 -12.34375 L 10.9375 0 L 9.65625 0 Z M 3.359375 -4.140625 L 8.171875 -4.140625 L 5.734375 -11 Z M 3.359375 -4.140625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.536322, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.3125 -10.609375 C 9 -10.910156 8.445312 -11.140625 7.65625 -11.296875 C 7.351562 -11.359375 6.96875 -11.390625 6.5 -11.390625 C 6.03125 -11.390625 5.535156 -11.273438 5.015625 -11.046875 C 4.492188 -10.828125 4.03125 -10.484375 3.625 -10.015625 C 2.769531 -8.972656 2.34375 -7.507812 2.34375 -5.625 C 2.34375 -3.75 2.769531 -2.4375 3.625 -1.6875 C 4.21875 -1.164062 5 -0.90625 5.96875 -0.90625 C 6.9375 -0.90625 7.867188 -1.023438 8.765625 -1.265625 L 8.84375 -5.46875 L 9.8125 -5.46875 L 9.8125 -0.703125 C 9.300781 -0.378906 8.367188 -0.144531 7.015625 0 C 6.640625 0.0507812 6.242188 0.078125 5.828125 0.078125 C 5.410156 0.078125 4.914062 0.0078125 4.34375 -0.125 C 3.78125 -0.257812 3.257812 -0.535156 2.78125 -0.953125 C 1.6875 -1.878906 1.140625 -3.421875 1.140625 -5.578125 C 1.140625 -7.742188 1.65625 -9.414062 2.6875 -10.59375 C 3.726562 -11.78125 5.066406 -12.375 6.703125 -12.375 L 7.265625 -12.34375 C 8.003906 -12.269531 8.566406 -12.128906 8.953125 -11.921875 C 9.347656 -11.722656 9.617188 -11.550781 9.765625 -11.40625 Z M 9.3125 -10.609375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.16575, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.734375 -11.28125 L 2.609375 -11.28125 L 2.609375 -6.640625 L 7.375 -6.640625 L 7.28125 -5.59375 L 2.609375 -5.59375 L 2.609375 -1.0625 L 8.171875 -1.0625 L 8.09375 0 L 1.40625 0 L 1.40625 -12.34375 L 7.828125 -12.34375 Z M 7.734375 -11.28125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.59273, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.265625 0 L 1.265625 -12.34375 L 2.46875 -12.34375 L 7 -3.3125 L 11.53125 -12.34375 L 12.71875 -12.34375 L 12.71875 0 L 11.609375 0 L 11.609375 -10.296875 L 7.59375 -2.3125 L 6.390625 -2.3125 L 2.375 -10.296875 L 2.375 0 Z M 1.265625 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.111768, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.734375 -11.28125 L 2.609375 -11.28125 L 2.609375 -6.640625 L 7.375 -6.640625 L 7.28125 -5.59375 L 2.609375 -5.59375 L 2.609375 -1.0625 L 8.171875 -1.0625 L 8.09375 0 L 1.40625 0 L 1.40625 -12.34375 L 7.828125 -12.34375 Z M 7.734375 -11.28125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.538748, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.328125 0 L 2.296875 -10.75 L 2.375 0 L 1.265625 0 L 1.265625 -12.34375 L 2.5625 -12.34375 L 9.578125 -1.59375 L 9.5 -12.34375 L 10.609375 -12.34375 L 10.609375 0 Z M 9.328125 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#569b40",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.590966, 247.706572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.28125 0 L 4.28125 -11.28125 L 0.796875 -11.28125 L 0.875 -12.34375 L 8.859375 -12.34375 L 8.78125 -11.28125 L 5.390625 -11.28125 L 5.390625 0 Z M 4.28125 0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordMarkLogo);
export default __webpack_public_path__ + "static/media/word_mark_logo.214d7eb0fef8e24ca3cc21e4bfd6247b.svg";
export { ForwardRef as ReactComponent };